// Copyright (c) 2025 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

function handleOnClick() {

    this.closeUpdateAmountOfUseModal();

}

const AmountOfUseUpdateModalHeader = props =>
    <header className='machine-update-modal-header'>
        <FormattedMessage
            id={`${props.amountOfUseModalAction}_AMOUNT_OF_USE`}
        />
        <span
            className='close-modal-icon'
            onClick={props::handleOnClick}
        />
    </header>;

AmountOfUseUpdateModalHeader.displayName = 'AmountOfUseUpdateModalHeader';
AmountOfUseUpdateModalHeader.propTypes = {
    amountOfUseModalAction: PropTypes.string.isRequired,
    closeUpdateStatusChangeModal: PropTypes.func.isRequired
};

export default AmountOfUseUpdateModalHeader;



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/update-amount-of-use/amount-of-use-update-modal-header.js